import { PageHeader } from "../components/PageHeader";
import { ContactCTA } from "../components/ContactCTA";
import { MaskWords, Reveal } from "../components/motion";
import { SectionLabel } from "../components/SectionLabel";

const STORY = [
  "Founded in New Zealand in 2019, Bio Smart Solutions Limited provides specialist expertise in agroecology, sustainable crop management and regenerative agricultural systems, with a strong focus on crop protection.",
  "Its work spans integrated pest management (IPM), biological control and functional biodiversity, including the use of beneficial organisms, biopesticides and biodiversity-based approaches to enhance natural pest control and strengthen crop resilience across a range of cropping systems.",
  "Bio Smart Solutions combines technical consultancy, applied R&D and field experimentation with knowledge transfer and extension, supporting growers, industry organisations and commercial partners in the development and adoption of practical, science-based solutions.",
];

const FOOTPRINT = [
  ["New Zealand", "Founded 2019", "Home base, consultancy, R&D and field experimentation.", "/images/rows.jpg"],
  ["Australia", "Partnerships", "Partnerships supporting our sourcing and commercial work.", "/images/greenhouse.jpg"],
  ["Pacific Islands", "Markets", "Established sourcing and commercial activities across island markets.", "/images/pacific.jpg"],
];

export default function About() {
  return (
    <main data-testid="about-page">
      <PageHeader
        testId="about-header"
        eyebrow="About us"
        lines={["Agroecology,", "applied with intent."]}
        intro="Specialist expertise in sustainable crop management and regenerative agricultural systems, with a strong focus on crop protection."
      />
      <section className="bg-paper py-20 sm:py-28">
        <div className="mx-auto grid max-w-[1440px] gap-16 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
          <div className="lg:col-span-4">
            <SectionLabel index="01" className="text-moss">Our story</SectionLabel>
            <Reveal className="arch mt-10 aspect-[3/4] overflow-hidden">
              <img src="/images/sprout.jpg" alt="Young crop seedlings" className="h-full w-full object-cover" />
            </Reveal>
          </div>
          <div className="space-y-8 lg:col-span-7 lg:col-start-6">
            <MaskWords className="font-display text-3xl font-light leading-[1.2] text-teal sm:text-4xl" text={STORY[0]} highlight={["agroecology", "crop", "protection"]} />
            {STORY.slice(1).map((p, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <p className="text-[17px] leading-[1.8] text-teal-ink/85">{p}</p>
              </Reveal>
            ))}
            <Reveal>
              <p className="text-[17px] leading-[1.8] text-teal-ink/85">
                The company also develops biological crop protection solutions and has established sourcing and commercial activities across Pacific Island markets, supported by partnerships in New Zealand and Australia.
              </p>
            </Reveal>
          </div>
        </div>
      </section>
      <section className="bg-mist py-20 sm:py-28">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
          <SectionLabel index="02" className="text-moss">Where we work</SectionLabel>
          <div className="mt-14 grid gap-6 md:grid-cols-3">
            {FOOTPRINT.map(([place, k, d, img], i) => (
              <Reveal key={place} delay={i * 0.1} data-testid={`footprint-${i}`} className="group bg-paper">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={img} alt={place} className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
                </div>
                <div className="p-6 sm:p-8">
                  <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-moss">{k}</p>
                  <h3 className="mt-2 font-display text-3xl font-normal text-teal">{place}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-teal-ink/80">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <ContactCTA />
    </main>
  );
}
